var render = function render(){var _vm=this,_c=_vm._self._c;return _c('amp-ad',{attrs:{"width":"100vw","height":"320","type":"adsense","data-ad-client":"ca-pub-8291978522401491","data-ad-slot":"7655161524","data-auto-format":"rspv","data-full-width":""}},[_c('div',{attrs:{"overflow":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }